const quizTypes = {
    SWITCH_PROGRAM_QUIZ: 'SWITCH_PROGRAM_QUIZ',
    IQOS_EXPERT_QUIZ: 'IQOS_EXPERT_QUIZ',
    QUEST_CHAMPION_QUIZ: 'QUEST_CHAMPION_QUIZ',
    STORY_QUIZ: 'STORY_QUIZ',
    REPORT_QUIZ: 'REPORT_QUIZ',
    QUIZ_CIRQULAR_PROGRAMME: 'QUIZ_CIRQULAR_PROGRAMME',
    GRAND_FINALE_QUIZ: 'GRAND_FINALE_QUIZ',
    HOW_TO_USE_QUIZ: 'HOW_TO_USE_QUIZ',
    TASTE_DISCOVERY_QUIZ: 'TASTE_DISCOVERY_QUIZ',
    MOTIVATION_QUIZ: 'MOTIVATION_QUIZ',
};

export default quizTypes;
